<template>
  <el-dialog :visible.sync="dialogVisible" custom-class="regNo-dialog" top="15vh" width="1020px" :fullscreen="isExpand" :show-close="false" :before-close="handleClose" :close-on-click-modal="false" :close-on-press-escape="false">
    <template slot="title">
      <div class="default-dialog-title-box">
        <span>增加产品注册证/备案凭证</span>
        <span class="icon-box">
          <img :src="!isExpand ? expandSvg : collapseSvg" @click="isExpand = !isExpand">
          <i class="el-icon-close" @click="handleClose"></i>
        </span>
      </div>
    </template>
    <el-form :model="form" ref="JZForm" :rules="rules" label-position="right" label-width="120px" size="mini">
      <el-row>
        <el-col :span="24">
          <el-form-item label="医疗器械分类" prop="medicalId">
            <el-cascader
              ref="cascaderRef"
              v-model="form.medicalId"
              :options="medicalTypeList"
              :props="medicalProps"
              clearable
              filterable
              @blur="handleBlurMedical"
              @change="handleChangeMedical"
              placeholder="请选择"
              style="width: 100%;">
            </el-cascader>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="注册人/备案人/代理人" prop="registrantName">
            <el-select v-model="form.registrantName" filterable remote :remote-method="remoteQueryRegistrantList" @change="handleChangeRegistrant" value-key="id" :loading="loading" placeholder="请选择">
              <el-option v-for="opt in registrantList" :key="'registrant'+opt.id" :label="opt.name" :value="opt">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="注册证号/备案凭证号" prop="registrationCode">
            <el-input v-model.trim="form.registrationCode" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="批准/备案日期" prop="approvalDate">
            <el-date-picker v-model="form.approvalDate" type="date" value-format="yyyy-MM-dd" placeholder="请选择" style="width: 100%;"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="16">
          <el-form-item label="有效期至" prop="effectiveDate">
            <el-date-picker v-model="form.effectiveDate" :disabled="forever" type="date" value-format="yyyy-MM-dd" placeholder="请选择"></el-date-picker>
            <el-checkbox v-model="forever" style="margin-left: 10px;">永久</el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="管理类别" prop="category">
            <el-select v-model="form.category" placeholder="请选择">
              <el-option v-for="opt in categoryList" :key="'category'+opt.value" :label="opt.label" :value="opt.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="厂商名称" prop="manufacturerName">
            <el-input v-model.trim="form.manufacturerName" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="厂商地区" prop="originAreaId">
            <area-cascader
              :provinceId.sync="form.originProvinceId"
              :provinceName.sync="form.originProvinceName"
              :cityId.sync="form.originCityId"
              :cityName.sync="form.originCityName"
              :areaId.sync="form.originAreaId"
              :areaName.sync="form.originAreaName"
              placeholder="请选择地区"
            />
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="详细地址" prop="originAddress">
            <el-input v-model.trim="form.originAddress" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="产品注册证/备案凭证图片" prop="annexList">
              <Upload
                v-model.trim="imagesList"
                label="设备图片"
                @success="handleFileLists"
                @remove="handleRemove"
                accept="image/png,image/jpeg,image/jpg"
                :maxSize="10"
                size="small"
                :tip="false"
                :limit="10"
              >
              </Upload>
              <div class="tip-upload">支持上传jpg、jpeg、png格式的文件，文件大小不得超过10M，最多上传 10 张</div>
            </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button  type="primary" @click="handleSave">保存</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { categoryList } from '@/enums/managerCategoryEnum';
import { treeByCodes, enterpriseList } from '@/api/category';
import { addRegisterProduct } from '@/api/registerNo';
import AreaCascader from '@/components/common/areaCascader';
export default {
  components: {
    Upload: () => import('@/components/common/upload'),
    AreaCascader,
  },
  data () {
    return {
      loading: false,
      isExpand: false,
      dialogVisible: false,
      expandSvg: require('@/assets/ic_expand.svg'),
      collapseSvg: require('@/assets/ic_collapse.svg'),
      forever: false,
      form: {
        approvalDate: '',
        category: '',
        effectiveDate: '',
        manufacturerName: '',
        medicalId: '',
        medicalPath: '',
        originAddress: '',
        originAreaId: '',
        originAreaName: '',
        originCityId: '',
        originCityName: '',
        originProvinceId: '',
        originProvinceName: '',
        registrantId: '',
        registrantName: '',
        registrationCode: '',
        // remark: '',
        annexList: [],
      },
      imagesList: [],
      categoryList,
      medicalProps: {
        value: 'id',
        label: 'name',
        children: 'children',
      },
      medicalTypeList: [],
      registrantList: [],
      rules: {
        medicalId: [
          { required: true, message: '请选择医疗器械分类', trigger: ['blur', 'change'] },
        ],
        registrantName: [
          { required: true, message: '请选择注册人/备案人/代理人', trigger: ['blur', 'change'] },
        ],
        registrationCode: [
          { required: true, message: '请输入注册证号/备案凭证号', trigger: ['blur', 'change'] },
        ],
        approvalDate: [
          { required: true, message: '请选择批准/备案日期', trigger: ['blur', 'change'] },
        ],
        effectiveDate: [
          { required: true, validator: this.validateEffectiveDate, trigger: ['blur', 'change'] },
        ],
        category: [
          { required: true, message: '请选择管理类别', trigger: ['blur', 'change'] },
        ],
        originAreaId: [
          { required: true, message: '请选择厂商地区', trigger: ['blur', 'change'] },
        ],
        annexList: [
          { required: true, validator: this.validateImages, trigger: ['blur', 'change'] },
        ],
      },
    };
  },
  watch: {
    dialogVisible (v) {
      if (v) {
        if (!this.medicalTypeList.length) {
          this.queryTreeByCodes();
        }
        if (!this.registrantList.length) {
          this.queryRegistrantList();
        }
      } else {
        this.form = this.$options.data().form;
        this.forever = this.$options.data().forever;
        this.imagesList = this.$options.data().imagesList;
        this.$refs.JZForm.resetFields();
      }
    },
    forever (v) {
      if (v) {
        this.form.effectiveDate = '9999-12-31';
      } else {
        this.form.effectiveDate = '';
      }
    },
  },
  methods: {
    validateEffectiveDate (rule, value, callback) {
      if (!value && !this.forever) {
        callback(new Error('请选择有效期'));
      } else {
        callback();
      }
    },
    validateImages (rule, value, callback) {
      if (!value?.length) {
        callback(new Error('请上传产品注册证/备案凭证图片'));
      } else {
        callback();
      }
    },
    handleChangeRegistrant (v) {
      this.form.registrantId = v.id;
      this.form.registrantName = v.name;
    },
    handleBlurMedical () {
      this.form.medicalId = '';
      this.form.medicalPath = '';
    },
    handleChangeMedical (value) {
      const categoryId = value.slice(-1)[0];
      // const selectedNodes = this.$refs.cascaderRef.getCheckedNodes();
      this.form.medicalId = categoryId;
      this.form.medicalPath = value.join(',');
    },
    handleRemove (file) {
      const index = this.imagesList.findIndex(v => v.url === file.url);
      this.imagesList.splice(index, 1);
      this.form.annexList = this.imagesList;
      this.$refs.JZForm.validateField('annexList');
    },
    handleFileLists (file) {
      this.imagesList.push({
        name: file.name,
        url: file.url,
      });
      this.form.annexList = this.imagesList;
      this.$refs.JZForm.clearValidate('annexList');
    },
    handleClose () {
      this.dialogVisible = false;
    },
    async handleSave () {
      this.$refs.JZForm.validate().then(async valid => {
        if (valid) {
          const approvalDate = new Date(this.form.approvalDate).getTime();
          const effectiveDate = new Date(this.form.effectiveDate).getTime();
          await addRegisterProduct({
            ...this.form,
            approvalDate,
            effectiveDate,
          });
          this.$message.success('保存成功');
          this.$emit('updateRegistration', this.form);
          this.handleClose();
        }
      });
    },
    async queryRegistrantList (query) {
      const { body } = await enterpriseList({
        ...query,
        orderBy: [
          {
            orderByProperty: 'lastUpdateTime',
            orderByType: 'ASC',
          },
        ],
        pageFlag: true,
        pageNum: 1,
        pageSize: 10,
      });
      this.registrantList = body?.list || [];
    },
    async remoteQueryRegistrantList (v) {
      this.loading = true;
      await this.queryRegistrantList({ name: v });
      this.loading = false;
    },
    queryTreeByCodes () {
      treeByCodes({
        codes: ['MEDICAL_DEVICE'],
        enableFlag: true,
        includeSelfFlag: true,
      }).then(res => {
        this.medicalTypeList = res.body || [];
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.regNo-dialog {
  /deep/ .el-dialog__header {
    padding: 16px 20px;
  }
  .tip-upload {
    font-weight: 400;
    font-size: 14px;
    color: #929AA6;
  }
}
</style>
